// A field a template names: ${ then a name of letters, digits and underscores, or two such names joined by a dot, then }.
const field = /\$\{([A-Za-z_][A-Za-z0-9_]*(?:\.[A-Za-z_][A-Za-z0-9_]*)?)\}/g;

/**
 * The value a name gives in vars: a plain name its own property, site.phone the phone of its site.
 * @param {Record<string, unknown>} vars
 * @param {string} name
 * @returns {unknown}
 */
const valueOf = (vars, name) => {
  /** @type {unknown} */
  let value = vars;
  for (const step of name.split(".")) {
    if (
      !value ||
      typeof value !== "object" ||
      !Object.prototype.hasOwnProperty.call(value, step)
    ) {
      return undefined;
    }
    value = /** @type {Record<string, unknown>} */ (value)[step];
  }
  return value;
};

/**
 * Substitutes data into a template.
 * A variable is referenced using ${variableName}, or ${site.phone} for a fact of the site; a name the data lacks stays as written.
 * The template is never run as code, so words that look like code show as words.
 * @param {string | undefined} template - a string containing variables, or none
 * @param {object} vars - an object with properties matching the variable names
 * @returns {string} - the template with the variables substituted
 */
const substitute = (template, vars = {}) => {
  if (template === undefined) {
    return "";
  }

  if (!vars || typeof vars !== "object") {
    return template;
  }

  /** @type {Record<string, unknown>} */
  const row = /** @type {Record<string, unknown>} */ (vars);
  return template.replace(field, (whole, name) => {
    const value = valueOf(row, name);
    return value != null && typeof value !== "object" ? String(value) : whole;
  });
};

export default {
  substitute,
};
